define('addonitems.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('addonitems', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Collection.Results\"></div>";
},"useData":true}, 'extensions/AnchorGroup/AddOnItems/1.0.1/', 'extensions/AnchorGroup/AddOnItems/1.0.1/', Handlebars);
});